function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.24999 5.00016C2.24999 3.57516 3.40832 2.41683 4.83332 2.41683H8.16666V0.833496H4.83332C2.53332 0.833496 0.666656 2.70016 0.666656 5.00016C0.666656 7.30016 2.53332 9.16683 4.83332 9.16683H8.16666V7.5835H4.83332C3.40832 7.5835 2.24999 6.42516 2.24999 5.00016ZM5.66666 5.8335H12.3333V4.16683H5.66666V5.8335ZM13.1667 0.833496H9.83332V2.41683H13.1667C14.5917 2.41683 15.75 3.57516 15.75 5.00016C15.75 6.42516 14.5917 7.5835 13.1667 7.5835H9.83332V9.16683H13.1667C15.4667 9.16683 17.3333 7.30016 17.3333 5.00016C17.3333 2.70016 15.4667 0.833496 13.1667 0.833496Z",
  fill: "white"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.792e0df4.svg";
export { ForwardRef as ReactComponent };